module.exports = __webpack_public_path__ + "img/IT0000101249233.0e743256.svg";